import { createContext } from "react";
const SubjectMasterProvider = createContext();
export default SubjectMasterProvider;

